module.exports = __webpack_public_path__ + "media/walking.e25f4ae4.mp4";